import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp } from "./Reveal";

const FranchiseBanner = () => (
  <section data-testid="franchise-banner" className="relative overflow-hidden bg-tmvred">
    <div className="pointer-events-none absolute inset-3 z-10 rounded-sm border border-gold/60" aria-hidden="true" />
    <div className="mx-auto flex max-w-7xl flex-col items-start gap-8 px-5 py-14 md:flex-row md:items-center md:justify-between md:px-10 md:py-16">
      <FadeUp>
        <p className="text-[11px] uppercase tracking-widest2 text-gold">Franchise Opportunity</p>
        <h2 className="mt-3 max-w-2xl font-display text-3xl leading-tight text-cream sm:text-4xl">
          Own your TMV Coffee &amp; Tea franchise
        </h2>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-cream/80">
          Franchise investment starts at <span className="font-semibold text-gold">₹2,00,000</span> —
          a business partnership with coffee and tea product distribution.
        </p>
      </FadeUp>
      <FadeUp delay={0.15} className="shrink-0">
        <Link
          data-testid="franchise-banner-cta"
          to="/franchise"
          className="group inline-flex items-center gap-3 rounded-full bg-gold px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-espresso transition-all duration-300 hover:bg-cream"
        >
          Explore Franchise
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </FadeUp>
    </div>
  </section>
);

export default FranchiseBanner;
